import styled, { css } from "styled-components";

export interface INotificationContainerWrapperProps {
  wasReaded: boolean;
}

export const NotificationContainerWrapper = styled.div<INotificationContainerWrapperProps>`
  grid-template-columns: auto 1fr;
  display: grid;
  gap: 0 12px;

  padding: 12px;

  ${({ wasReaded }) =>
    wasReaded
      ? css`
          opacity: 0.6;
          border-left: 2px solid
            ${({ theme }) => theme.notification.defaultNotification.borderLeft};
        `
      : css`
          border-left: 2px solid
            ${({ theme }) => theme.notification.defaultNotification.borderLeft};
          background: ${({ theme }) =>
            theme.notification.defaultNotification.background};
        `}
`;
